import './styles/index.scss'
import 'normalize.css'
import 'animate.css'

const globalState = {
  subscribeIsOpen: false,
  subscribeName: undefined,
  subscribeEmail: undefined,
  subscribeRequest: undefined,
}

const handleToggleSubscribeModal = () => {
  globalState.subscribeIsOpen = !globalState.subscribeIsOpen
  const modal = document.querySelector('.modal')
  if (modal) {
    modal.classList.toggle('open', globalState.subscribeIsOpen)
  }
}

document.addEventListener('keydown', function (event: KeyboardEvent) {
  if (event.key === 'Escape') {
    globalState.subscribeIsOpen = false
    const modal = document.querySelector('.modal')
    if (modal) {
      modal.classList.remove('open')
    }
  }
})

document.addEventListener('click', function (event: MouseEvent) {
  const target = event.target as HTMLElement
  if (target.closest('.request-button')) {
    handleToggleSubscribeModal()
    return
  }

  if (target.closest('.modal-close')) {
    globalState.subscribeIsOpen = false
    const modal = document.querySelector('.modal')
    if (modal) modal.classList.remove('open')
    return
  }
})

document.querySelector('.backdrop')?.addEventListener('click', function () {
  globalState.subscribeIsOpen = false
  const modal = document.querySelector('.modal')
  if (modal) {
    modal.classList.remove('open')
  }
})

const nav = document.getElementById('navigation')

window.addEventListener('scroll', () => {
  if (!nav) return

  if (window.scrollY >= 300 && !nav.classList.contains('sticky')) {
    nav.classList.add('sticky')
  }
  if (window.scrollY < 300 && nav.classList.contains('sticky')) {
    nav.classList.remove('sticky')
  }
})

const animateCSS = (node: HTMLElement, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve) => {
    const animation = node.dataset.animation || 'fadeInUp'
    const speed = node.dataset.speed || 'slow'
    const delay = node.dataset.delay || undefined
    const animationName = `${prefix}${animation}`

    if (delay) {
      node.style.setProperty('--animate-duration', delay)
    }

    node.classList.add(`${prefix}animated`, animationName, `${prefix}${speed}`)

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event: any) {
      event.stopPropagation()
      node.classList.remove(`${prefix}animated`, animationName)
      resolve('Animation ended')
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true })
  })

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCSS(entry.target as HTMLElement)
        observer.unobserve(entry.target) // отключаем, если нужно анимацию один раз
      }
    })
  },
  {
    threshold: 0.1, // сработает, когда хотя бы 10% элемента видны
  },
)

document.querySelectorAll('.animate').forEach((el) => {
  observer.observe(el)
})

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contactForm') as HTMLFormElement

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    const formData = new FormData(form)
    const data = {
      name: formData.get('name'),
      phone: formData.get('phone'),
      message: formData.get('message'),
      email: formData.get('email'),
    }

    if (!data.email && !data.phone) {
      alert('Вкажіть будь ласка email або номер телефону')
      return
    }

    try {
      const response = await fetch('/api/send-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })

      if (response.ok) {
        alert('Повідомлення надіслано!')
        form.reset()
        document.querySelector('.modal')?.classList.remove('open')
      } else {
        alert('Помилка при надсиланні повідомлення.')
      }
    } catch (err) {
      console.error(err)
      alert('Сталася помилка. Спробуйте пізніше.')
    }
  })
})

const burger = document.querySelector('.burger')
const menu = document.querySelector('.toolbar-menu')

burger?.addEventListener('click', () => {
  menu?.classList.toggle('open')
})

menu?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    menu.classList.remove('open')
  })
})
